import { isInIframe } from "@/wbcontroller/util";
import { WBState } from "./stateInterfaceType";
import WhiteboardConfig from "@/WhiteboardConfig";
import {
  jsonToWhiteboardData,
  getFolderNavigationMap,
} from "./initialStateHelpers";
import ToolType from "@/wbcontroller/types/ToolType";

export function getInitialState(
  config: WhiteboardConfig,
  initialStrokeColor: string,
  initialStrokeWidth: number,
  initialStickyColor: string,
  initialTool: ToolType
): WBState {
  return {
    // app
    debug: config.debug,
    isInIframe: isInIframe(),
    featureFlags: Object.assign({}, config.feature_flag),

    // board
    key: config.key
      ? {
          id: config.key.id,
          accessLevel: config.key.access_level,
        }
      : {
          id: `${Math.random()}`,
          accessLevel: "admin",
        },
    shareURLs: config.share_urls,
    whiteboard: jsonToWhiteboardData(config.whiteboard),
    isLocked: false,

    // folders (unused)
    folder: config.folder
      ? {
          name: config.folder.name,
          whiteboards: config.folder.whiteboards.map(jsonToWhiteboardData),
        }
      : null,
    folderNavigation: getFolderNavigationMap(config),

    // collab info
    activeUsers: {},

    // UI state

    selectedShapes: [],
    hud: {
      strokeColor: initialStrokeColor,
      strokeWidth: initialStrokeWidth,
      strokeWidthForEraser: 20,
      fillColor: "rgba(0, 0, 0, 0)",
      fillColorForSticky: initialStickyColor,
      strokeColorNoSelection: initialStrokeColor,
      strokeWidthNoSelection: initialStrokeWidth,
      fillColorNoSelection: "rgba(0, 0, 0, 0)",
      fillColorForStickyNoSelection: initialStickyColor,
      changedKeys: [],
      tool: initialTool,
      opacity: 0.3,
    },
    hudUI: {
      isColorPickerOpen: false,
    },
    pendingPDF: null,
  };
}
